<template>
	<div v-if="assessment" class="assessment-panel assessment-panel--disc">
		<AssessmentHeader
			:user="user"
			:assessment="assessment"
		/>
		<TendencyCharacteristics
			:assessment="assessment"
			:is-skeleton="false"
			:auto-skeleton="false"
		/>
		<DrivenCharacteristics
			:assessment="assessment"
			:is-skeleton="false"
			:auto-skeleton="false"
		/>
		<InfluenceCharacteristics
			:assessment="assessment"
			:is-skeleton="false"
			:auto-skeleton="false"
		/>
		<EnergizingCharacteristics
			:assessment="assessment"
			:is-skeleton="false"
			:auto-skeleton="false"
		/>
		<DrainingCharacteristics
			:assessment="assessment"
			:is-skeleton="false"
			:auto-skeleton="false"
		/>
	</div>
	<AssessmentPrompt
		v-else
		class="assessment-panel assessment-panel--prompt"
		:user="user"
		:is-current-user="isCurrentUser"
		:error="error"
		v-on="bubble( `prompt` )"
	/>
</template>

<script>
import EventsMixin from "../../mixins/EventsMixin";
import AssessmentHeader from "./AssessmentHeader";
import AssessmentPrompt from "./AssessmentPrompt";
import TendencyCharacteristics from "./characteristics/TendencyCharacteristics";
import DrivenCharacteristics from "./characteristics/DrivenCharacteristics";
import InfluenceCharacteristics from "./characteristics/InfluenceCharacteristics";
import EnergizingCharacteristics from "./characteristics/EnergizingCharacteristics";
import DrainingCharacteristics from "./characteristics/DrainingCharacteristics";

export default {
	name: "CharacteristicsPanel",
	mixins: [ EventsMixin, ],
	emits: [ "prompt", ],
	components: {
		AssessmentHeader,
		AssessmentPrompt,
		TendencyCharacteristics,
		DrivenCharacteristics,
		InfluenceCharacteristics,
		EnergizingCharacteristics,
		DrainingCharacteristics,
	},
	props: {
		user: {
			type: Object,
			required: true,
		},
		isCurrentUser: {
			type: Boolean,
			required: true,
		},
		error: {
			type: String,
			required: true,
		},
	},
	computed: {
		assessment() {
			return this.user?.assessments?.DISC;
		},
	},
};
</script>

<style lang="scss" scoped>
.assessment-panel {
	display: flex;
	flex-direction: column;
	gap: 1rem;

	@include for-size('md') {
		gap: 2rem;
	}

}
</style>
